import { render, staticRenderFns } from "./attendanceChart.vue?vue&type=template&id=64b32c3a&"
import script from "./attendanceChart.vue?vue&type=script&lang=js&"
export * from "./attendanceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports